// extracted by mini-css-extract-plugin
export default {"fsDropdownMenu":"dropdown-module--fs-dropdown-menu--d1926"};